import React from 'react';

const EmptyStateCircle = () => (
    <svg fill="none" height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M59.936 30C59.936 46.5685 46.5189 60 29.968 60C13.4171 60 0 46.5685 0 30C0 13.4315 13.4171 0 29.968 0C46.5189 0 59.936 13.4315 59.936 30ZM11.9872 30C11.9872 39.9411 20.0375 48 29.968 48C39.8985 48 47.9488 39.9411 47.9488 30C47.9488 20.0589 39.8985 12 29.968 12C20.0375 12 11.9872 20.0589 11.9872 30Z"
            fill="url(#paint0_linear)"
        />
        <path
            d="M29.968 0C33.9034 4.69799e-08 37.8004 0.775973 41.4362 2.28361C45.0721 3.79126 48.3758 6.00104 51.1586 8.7868C53.9414 11.5726 56.1488 14.8797 57.6548 18.5195C59.1608 22.1593 59.936 26.0603 59.936 30L47.9488 30C47.9488 27.6362 47.4837 25.2956 46.5801 23.1117C45.6765 20.9278 44.352 18.9435 42.6823 17.2721C41.0127 15.6006 39.0305 14.2748 36.8489 13.3702C34.6674 12.4656 32.3293 12 29.968 12V0Z"
            fill="url(#paint1_linear)"
        />
        <defs>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear"
                x1="-1.46468e-07"
                x2="59.936"
                y1="39.2044"
                y2="39.2044"
            >
                <stop offset="0.163729" stopColor="#EFEFEF" />
                <stop offset="1" stopColor="#EFEFEF" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint1_linear"
                x1="45.3219"
                x2="58.5406"
                y1="-1.62264"
                y2="26.5911"
            >
                <stop stopColor="#BECAE0" />
                <stop offset="1" stopColor="#BECAE0" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>
);

export default EmptyStateCircle;
